goog.provide("shadow.js.shim.module$keycloak_js");
goog.provide("module$shadow_js_shim_module$keycloak_js");
shadow.js.shim.module$keycloak_js = shadow.js.nativeProvides["keycloak-js"] = shadow$bridge("keycloak-js");
module$shadow_js_shim_module$keycloak_js.default = shadow.js.shim.module$keycloak_js;
